import { token } from '@atlaskit/tokens';
import styled from '@emotion/styled';

export const StyledFooter = styled.div<{ isDesignIteration1Enabled?: boolean }>`
  font-size: ${token('font.body.small', '12px')};
  background-color: ${(props) =>
    props.isDesignIteration1Enabled ? `${token('color.background.neutral.subtle.hovered', '#f4f5f7')}` : 'none'};
  padding: ${(props) => (props.isDesignIteration1Enabled ? `${token('space.250', '20px')}` : `${token('space.0')}`)};
  border-radius: ${(props) =>
    props.isDesignIteration1Enabled ? `${token('space.050', '4px')}` : `${token('space.0')}`};
`;
